export const IconPhone = ({ size, color }) => (
  <div style={{ marginRight: `0.5rem` }}>
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9016 10.827C11.3003 11.1663 11.3004 11.7113 10.8966 12.0486L9.9167 12.8672C9.51524 13.2026 8.78668 13.3582 8.29806 13.1872C8.29806 13.1872 6.32366 12.8071 3.87982 10.3118C1.43597 7.81662 1.06364 5.80073 1.06364 5.80073C0.908274 5.29788 1.04675 4.56027 1.37707 4.14806L2.17883 3.14753C2.5073 2.73764 3.04265 2.73504 3.37522 3.14251L4.5854 4.62524C4.80668 4.89636 4.83191 5.35224 4.63883 5.64794L4.10106 6.47154C4.10106 6.47154 4.10758 7.83359 5.20731 8.95644C6.30704 10.0793 7.64105 10.0859 7.64105 10.0859L8.44769 9.53687C8.73535 9.34107 9.18581 9.3672 9.44934 9.59142L10.9016 10.827Z"
        stroke={color !== '' ? color : `white`}
        strokeWidth="0.999429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 7.12866C13 3.74389 10.3137 1 7 1"
        stroke={color !== '' ? color : `white`}
        strokeWidth="0.999429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3 7.12857C10.3 5.26695 8.82253 3.75781 7 3.75781"
        stroke={color !== '' ? color : `white`}
        strokeWidth="0.999429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)
